import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { authStorage } from '../../lib/auth-storage'
import { USER_ROLES } from '../../types/auth'

export function GuestRoute() {
  const { session, dashboardPath } = useAuth()
  const token = authStorage.getToken()

  if (token && session) {
    const target =
      session.role === USER_ROLES.DOCTOR && session.user.status !== 'approved'
        ? '/account-status'
        : (session.dashboard_path ?? dashboardPath)

    return <Navigate to={target} replace />
  }

  return <Outlet />
}
